import { TaskStatus } from "Util/enums";

export interface DespatchGlobalFilters {
  searchTerm: string;
  companyIdSelected: number | null;
  companyIds: number[];
  branchIds: number[];
  tasksStatuses: TaskStatus[] | null | undefined;
  tasksTypeNames: string[];
  departament: "warehouse" | "road" | null;
  warehouseIds: number[];
  allCompanies: boolean;
  allBranches: boolean;
  allTaskTypes: boolean;
  allWarehouses: boolean;
}

export const getDefaultDespatchFilterValues = (
  defaultCompanyId?: number,
  defaultCompaniesIds?: number[],
  defaultTaskTypes?: string[]
): DespatchGlobalFilters => ({
  tasksStatuses: null,
  searchTerm: "",
  departament: null,
  companyIds: defaultCompaniesIds || (defaultCompanyId ? [defaultCompanyId] : []),
  branchIds: [],
  tasksTypeNames: defaultTaskTypes || [],
  warehouseIds: [],
  allCompanies: true,
  allBranches: true,
  allTaskTypes: true,
  allWarehouses: true,
  companyIdSelected: defaultCompanyId || null,
});

export const UNPUBLISHED_TASKS = [
  TaskStatus.CANCELLED,
  TaskStatus.REGISTERED,
  TaskStatus.WAITING_PUBLISH,
];

export const PUBLISHED_TASKS = [
  TaskStatus.PENDING_ACCEPT,
  TaskStatus.STARTED,
  TaskStatus.FINISHED,
  TaskStatus.ACCEPTED,
];

export enum DispatchGlobalFilters {
  MEMBERS = "members",
  EQUIPMENT = "equipment",
  STORAGE_BOXES = "storageBoxes",
  ORDER_REFERENCE = "orderReference",
}
